import {Button} from "antd";
import WrappedPre from "../util/WrappedPre";
import React from "react";
import useCopy from "../hooks/useCopy";

const ImageExifSection = ({exifInfo}) => {
    const {copyValue} = useCopy();
    return (<React.Fragment>
        <div className="exif-section-heading">
            <h2>Exif</h2>
            <Button onClick={() => copyValue(exifInfo.text)}>
                Copy
            </Button>
        </div>
        <div style={{position: 'relative'}}>

            <WrappedPre style={{overflowY: 'scroll', maxHeight: '300px'}}>{exifInfo.text}</WrappedPre>
        </div>
    </React.Fragment>);
}

export default ImageExifSection;


// WEBPACK FOOTER //
// ./src/exif/ImageExifSection.js